import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import Icon from '../../../Icons'
import DetailsItem from '../components/DetailsItem/DetailsItem'
import { mapActivityDetails } from '../helpers'

const RewardsActivityDetailsModal = ({ onClose = () => {}, activity, building }) => {
  const { t } = useTranslation(['rewards-loyalty', 'common'])
  const { timezone } = building

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards-loyalty:activityDetailsModal.headerTitle')}
      headerIcon={<Icon icon="walk" viewBox="0 0 18 21" svgProps={{ fillRule: 'evenodd' }} />}
    >
      <div
        className="rewards-modal-content rewards-base-view activity-evidence"
        style={{ paddingBottom: 20 }}
      >
        <DetailsItem data={mapActivityDetails(activity, timezone, t)} />
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onClose}>
          {t('common:actions.back')}
        </button>
      </div>
    </ModalContainer>
  )
}

RewardsActivityDetailsModal.propTypes = {
  onClose: PropTypes.func,
  activity: PropTypes.object,
  building: PropTypes.object,
}

export default RewardsActivityDetailsModal
